// /src/components/PublicTocPanel.jsx

import React, { useState, useEffect, useRef } from "react";

export default function PublicTocPanel({ toc, containerRef, onClose }) {
  const [closing, setClosing] = useState(false);
  const innerRef = useRef(null);

  useEffect(() => {
    const handler = () => setClosing(true);
    window.addEventListener("close-public-toc", handler);
    return () => window.removeEventListener("close-public-toc", handler);
  }, []);

  useEffect(() => {
    if (!closing) return;
    const el = innerRef.current;
    if (!el) return;

    const onEnd = () => onClose();
    el.addEventListener("animationend", onEnd);
    return () => el.removeEventListener("animationend", onEnd);
  }, [closing, onClose]);

  const scrollTo = (i) => {
    const item = toc[i];
    if (!item) return;

    const root = containerRef.current;
    if (!root) return;

    const targets = root.querySelectorAll(
      `h${item.level}.lexical-header${item.level}`
    );

    for (const t of targets) {
      const txt = t.textContent.replace(/\s+/g, "").toLowerCase();
      if (txt.includes(item.text.replace(/\s+/g, "").toLowerCase())) {
        const rect = t.getBoundingClientRect();
        window.scrollTo({
          top: rect.top + window.scrollY - 100,
          behavior: "smooth",
        });
        break;
      }
    }
  };

  return (
    <div className="public-toc-panel">
      <div
        ref={innerRef}
        className={`public-toc-panel-inner ${closing ? "closing" : ""}`}
      >
        <ul className="public-toc-list glass-card">
          <div className="public-toc-header">
            <span>Content table</span>
          </div>
          <div className="public-toc-content">
              {toc.map((entry, index) => (
                <li
                  key={index}
                  className={`toc-entry toc-h${entry.level}`}
                  onClick={() => scrollTo(index)}
                >
                  {entry.numbering ? entry.numbering + " " : ""}
                  {entry.text}
                </li>
              ))}
          </div>
         
        </ul>
      </div>
    </div>
  );
}
